import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowRight } from 'lucide-react';
import Cities from './Cities';
import { SET_SELECTED_FILTERS } from '../../../redux/actions/types';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';

const Locations = ({ onApplyFilters, onLogin }) => {
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const dispatch = useDispatch();
  const selectedFilters = useSelector((store) => store?.hallOfFame?.selectedFilters);
  const recruiterAccessToken = useSelector((store) => store?.hallOfFame?.recruiterAccessToken);

  const locations = [
    { city: 'Pune' },
    { city: 'Mumbai' },
    { city: 'Bangalore' },
    { city: 'Hyderabad' },
    { city: 'Chennai' },
  ];

  const fetchLocations = (city) => {
    if (!recruiterAccessToken) {
      onLogin();
      return;
    }
    Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_APPLY_FILTERS_SUBMITTED);

    const newFilters = { ...selectedFilters, cities: [city] };
    dispatch({ type: SET_SELECTED_FILTERS, payload: newFilters });
    onApplyFilters(newFilters);
  }


  return (
    <div className="relative w-full max-w-[340px] md:max-w-[400px] bg-[#051120] rounded-[24px] overflow-hidden p-6 border border-[#1E293B] shadow-xl md:hidden">
      {/* Grid Background Pattern */}
      <div className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          backgroundImage: 'linear-gradient(#2D3F54 1px, transparent 1px), linear-gradient(90deg, #2D3F54 1px, transparent 1px)',
          backgroundSize: '24px 24px'
        }}
      ></div>

      {/* Radial Gradient Overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#0A1A2F] to-transparent opacity-60 pointer-events-none"></div>

      <div className="relative z-10 flex flex-col items-center gap-5">
        <h3 className="text-white text-xl md:text-2xl font-bold text-center leading-tight">
          Find Candidates by Location
        </h3>

        <div className="flex flex-wrap justify-center gap-2 w-full">
          {locations.map((item, index) => (
            <div
              key={index}
              onClick={() => fetchLocations(item.city)}
              className="flex items-center gap-1.5 bg-[#0F2335] border border-[#1C3648] rounded-full px-3.5 py-1.5 shadow-sm cursor-pointer"
            >
              <span className="text-[#00F695] font-semibold text-sm">
                {item.city}
              </span>
            </div>
          ))}
        </div>

        <button className="w-full flex items-center justify-center gap-2 border border-[#2D3F54] text-[#00F695] rounded-xl py-3 hover:bg-[#0F2232] hover:border-[#00F695]/30 transition-all duration-300 font-medium text-sm md:text-base mt-2 group" onClick={() => {
          if (!recruiterAccessToken) {
            onLogin();
            return;
          }
          Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_CITIES_CLICKED);
          setIsCityModalOpen(true);
        }}>
          Explore All Locations
          <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
        </button>
      </div>
      <Cities isOpen={isCityModalOpen} onClose={() => setIsCityModalOpen(false)} onApplyFilters={onApplyFilters} />
    </div>
  );
};

export default Locations;
